<template>
  <div>
    <div class="rate-detail" v-if="rateDialog">
      <div class="mask" @click="rateDialog = false"></div>
      <div class="rate-content">
        <div class="rate-close" @click="rateDialog = false">关闭</div>
        <div class="rate-title">{{ name }}</div>
        <div class="content-content">
          <div class="rate-left">
            <div class="rate-left-title">{{ score }} 分</div>
            <div class="rate-left-info">
              <div
                class="rate-list"
                v-for="(item, index) in scoreClass"
                :key="index"
              >
                <div class="list-name">{{ item.name }}：</div>
                <div class="list-score">{{ item.num }}</div>
              </div>
            </div>
          </div>
          <div class="rate-chart">
            <div id="rate-pie"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Echarts from "echarts";
export default {
  name: "rateListPie",
  components: {},
  props: {
    rateCount: {
      type: Number,
      default: {
        return: 0,
      },
    },
    echartsData: {
      type: Object,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      rateDialog: false,
      myChart: {},
      name: "",
      score: "",
      scoreClass: [],
    };
  },
  created() {},
  mounted() {
    let _this = this;
    // window.onresize = function() {
    //   _this.myChart.resize();
    // };
  },
  computed: {},
  watch: {
    rateCount: function(newVal) {
      // console.log(newVal)
      this.rateDialog = true;
      this.name = this.echartsData.name;
      this.score = this.echartsData.score;
      this.scoreClass = this.echartsData.scoreClass;
      setTimeout(() => {
        this.loadEchart();
      }, 300);
    }
  },
  methods: {
    loadEchart() {
      let colors = [
        "#4D94DE",
        "#B9C76D",
        "#E55988",
        "#8DD278",
        "#69EC91",
        "#937BF5",
        "#EE906D",
      ];
      this.myChart = Echarts.init(document.getElementById("rate-pie"));
      let option = {
        title: {
          // text: "",
        },
        tooltip: {
          // trigger: "axis",
        },
        legend: {
          // type: 'scroll',
          orient: "vertical",
          bottom: "center",
          right: 0,
          top: "center",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: "#C4CDFF",
          },
          data: [],
        },
        grid: {
          top: "5%",
          left: "5%",
          right: "10%",
          bottom: "20%",
          containLabel: true,
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [],
            right: "80",
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: '{d}%'
            }
          },
        ],
        color: colors,
      };
      option.series[0].data = this.scoreClass.map((item) => {
        // console.log(item);
        return {
          name: item.name || "",
          value: item.num || 0,
        };
      });
      option.legend.data = this.scoreClass.map((item) => {
        // console.log(item);
        return {
          name: item.name || "",
        };
      });
      // console.log(option.xAxis.data)
      // console.log(option.legend.data)

      this.myChart.setOption(option);
    },
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.rate-detail {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2001;
  }
  .rate-content {
    width: 780px;
    height: 650px;
    padding: 40px;
      // 已修改
    background: url("~@/assets/img/hiddenDangerNow/hidden-detail-dialog-bg.png") center center no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -390px;
    margin-left: -325px;
    z-index: 2002;
    .rate-close {
      width: 56px;
      height: 24px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #d7deff;
      text-align: center;
      line-height: 25px;
      letter-spacing: 1px;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }
    .rate-title {
      font-size: 30px;
      color: #ffffff;
      padding-bottom: 20px;
      text-align: center;
    }
    .content-content {
      margin-top: -50px;
      display: flex;
      justify-content: center;
      // align-items: center;
    }
    .rate-left {
      width: 280px;
      padding-left: 20px;
    }
    .rate-left-title {
      font-size: 16px;
      color: #ffffff;
      margin-top: 110px;
      margin-bottom: 50px;
    }
    .rate-left-info {
      font-size: 16px;
      color: #ffffff;
      .rate-list {
        margin-bottom: 10px;
      }
    }
    .rate-list {
      display: flex;
      justify-content: flex-start;
      // align-items: center;
    }
    .rate-chart {
      width: 500px;
      height: 500px;
      padding-bottom: 20px;
    }
  }
}
#rate-pie {
  width: 500px;
  height: 500px;
}
</style>
